import formatterMonetaryValue from '@/app/utils/numberUtils';
import { Box, Divider, Stack, Typography, useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import FormFieldLong from '../project/baseForms/FormFieldLong';
import InfoTotalValue from '../project/baseForms/info/InfoTotalValue';

interface ReportItemProps {
  name: string;
  value: number | string | null;
  justify: string;
  index?: number;
  onJustifyChange?: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onJustifyChangeWithIndex?: (index: number, newValue: string) => void;
  isLast?: boolean;
  header?: boolean;
}

function ReportItem({
  name,
  value,
  justify,
  index,
  onJustifyChange,
  onJustifyChangeWithIndex,
  isLast,
  header = false,
}: ReportItemProps) {
  const { t } = useTranslation(['costTracking', 'common']);
  const theme = useTheme();

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onJustifyChange) {
      onJustifyChange(e);
    }
    if (onJustifyChangeWithIndex && index !== undefined) {
      onJustifyChangeWithIndex(index, e.target.value);
    }
  };

  return (
    <Box sx={{ flexGrow: 1, mt: 1 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          mt: 1,
          mb: -2,
        }}
      >
        <Typography
          variant="h2"
          sx={{
            width: header ? theme.spacing(20) : theme.spacing(10),
            mb: 0,
            whiteSpace: 'nowrap',
          }}
        >
          {t(name)}
        </Typography>

        <Stack direction="row" sx={{ flexGrow: 1 }}>
          <InfoTotalValue
            value={formatterMonetaryValue(value)}
            sx={{
              alignItems: 'center',
              display: 'flex',
            }}
          />
        </Stack>
      </Box>

      <FormFieldLong label={t('common:comment')} value={justify} onChange={handleOnChange} width={theme.spacing(70)} />

      {!isLast && (
        <Divider
          sx={{
            mt: 1,
            mb: 1,
            borderColor: 'rgba(0, 0, 0, 0.12)',
            width: theme.spacing(70),
          }}
        />
      )}
    </Box>
  );
}

export default ReportItem;
